<div class="background-color-white pr-20 pl-20 pt-10 pb-10">
  <div id="legend-container" class="display-grid">
    <div *ngFor="let item of items" class="display-flex flex-align-center overflow-hidden" [ngStyle]="{height: '25px'}">
      <span [ngStyle]="{width: '10px', height: '10px', backgroundColor: item.color, marginRight: '10px', marginLeft: '10px', borderRadius: '50%'}"></span>
      <span class="text-ellipsis">{{ item.name | translate }}</span>
    </div>
  </div>
</div>
